var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.scancodeshow)?_c('div',{staticClass:"g-scancode-box"},[_c('img',{attrs:{"src":require("../assets/images/tips-img-sm.png")}}),_c('h1',[_vm._v("请用微信或者支付宝扫码")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }